module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_waiting_list")) + ": " + _vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width",
    style: (_vm.tableStyle())
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_username")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "new-button"
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete")) + "\n                ")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('div', {
    staticClass: "foo"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d470338!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/DeleteWaitingListModal.vue
// module id = 727
// module chunks = 0